var _mask, _path, _circle, _circle2, _mask2, _path2, _circle3, _circle4, _circle5, _mask3, _path3, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMugsAngle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 684,
    height: 104,
    viewBox: "0 0 684 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13046_24988",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 56C62 53.7909 63.7909 52 66 52H90V72H66C63.7909 72 62 70.2091 62 68V56Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 56C58 51.5817 61.5817 48 66 48H91L89 56H66H58ZM91 76H66C61.5817 76 58 72.4183 58 68H66H89L91 76ZM66 76C61.5817 76 58 72.4183 58 68V56C58 51.5817 61.5817 48 66 48V56V68V76ZM91 48V76L89 68V56L91 48Z",
    fill: "#CCCCCC",
    mask: "url(#path-1-inside-1_13046_24988)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 62,
    r: 34,
    stroke: "#CCCCCC",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 96,
    r: 8,
    fill: "#3D98F2"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_13046_24988",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348 -1.74846e-07C350.209 -7.8281e-08 352 1.79086 352 4L352 28L332 28L332 4C332 1.79086 333.791 -7.95947e-07 336 -6.99382e-07L348 -1.74846e-07Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M348 -4C352.418 -4 356 -0.418278 356 4L356 29L348 27L348 4L348 -4ZM328 29L328 4C328 -0.418279 331.582 -4 336 -4L336 4L336 27L328 29ZM328 4C328 -0.418279 331.582 -4 336 -4L348 -4C352.418 -4 356 -0.418278 356 4L348 4L336 4L328 4ZM356 29L328 29L336 27L348 27L356 29Z",
    fill: "#CCCCCC",
    mask: "url(#path-5-inside-2_13046_24988)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 62,
    r: 34,
    stroke: "#CCCCCC",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 96,
    r: 8,
    fill: "#3D98F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 62,
    r: 34,
    stroke: "#CCCCCC",
    strokeWidth: 4
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-3_13046_24988",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622 68C622 70.2091 620.209 72 618 72L594 72L594 52L618 52C620.209 52 622 53.7909 622 56L622 68Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M626 68C626 72.4183 622.418 76 618 76L593 76L595 68L618 68L626 68ZM593 48L618 48C622.418 48 626 51.5817 626 56L618 56L595 56L593 48ZM618 48C622.418 48 626 51.5817 626 56L626 68C626 72.4183 622.418 76 618 76L618 68L618 56L618 48ZM593 76L593 48L595 56L595 68L593 76Z",
    fill: "#CCCCCC",
    mask: "url(#path-10-inside-3_13046_24988)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 96,
    r: 8,
    fill: "#3D98F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMugsAngle);
export default __webpack_public_path__ + "static/media/mugs-angle.7dc2d5a80d7f66e83e474a0c3ba76c13.svg";
export { ForwardRef as ReactComponent };